import { Injectable } from '@angular/core';
import { CommonRegEx } from '../../validators/match.pattern.validator';

@Injectable({
  providedIn: 'root'
})
export class UrlValidationService {
  validation = new RegExp(CommonRegEx.APPLICATION_URL_REGEX);
  ipv4_with_port = new RegExp(CommonRegEx.IP4_STR);
  urlValidationWarningMessage = '';
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
  public isUrlValid(urlValues: string): { isValidUrl: boolean; errorMessage?: string } {
    const urlStartsRegex = new RegExp(CommonRegEx.URL_START_REGEX, 'i');
    urlValues = urlValues?.toLowerCase();
    if ((urlValues && this.validation.test(urlValues)) || urlStartsRegex.test(urlValues)) {
      const sliceStart = urlValues.toLowerCase().startsWith('http://')
        ? 7
        : urlValues.toLowerCase().startsWith('https://')
        ? 8
        : 0;

      urlValues = urlValues.slice(sliceStart);
      // check for valid ipv4 port
      if (this.ipv4_with_port.test(urlValues) && urlValues.includes(':')) {
        const userEnteredPort = urlValues.substring(urlValues.indexOf(':') + 1);
        if (
          (userEnteredPort && userEnteredPort.includes(':')) ||
          (userEnteredPort && (parseInt(userEnteredPort) < 1 || parseInt(userEnteredPort) >= 65536))
        ) {
          return { isValidUrl: false, errorMessage: 'Please enter proper port' };
        }
      }

      return {
        isValidUrl: this.validation.test(urlValues) ? true : false,
        errorMessage: this.validation.test(urlValues) ? '' : 'Please enter proper url'
      };
    } else {
      // check for ipv6 with port
      if (
        (urlValues && urlValues.startsWith('[')) ||
        (this.ipv4_with_port.test(urlValues) && urlValues.includes(':'))
      ) {
        const ipv6_and_ipv4_with_port = urlValues.replace(/\s|\[|\]/g, '');
        let isPortRange = true;
        const userEnteredPort = this.ipv4_with_port.test(urlValues)
          ? ipv6_and_ipv4_with_port.substring(ipv6_and_ipv4_with_port.lastIndexOf(':') + 1)
          : urlValues.endsWith(']')
          ? ''
          : ipv6_and_ipv4_with_port.substring(ipv6_and_ipv4_with_port.lastIndexOf(':') + 1);

        if (
          (userEnteredPort && isNaN(parseInt(userEnteredPort))) ||
          urlValues.endsWith(':') ||
          (userEnteredPort && (parseInt(userEnteredPort) < 1 || parseInt(userEnteredPort) >= 65536))
        ) {
          isPortRange = false;
        }

        return {
          isValidUrl:
            this.validation.test(
              ipv6_and_ipv4_with_port.substring(0, ipv6_and_ipv4_with_port.lastIndexOf(':'))
            ) && isPortRange,
          errorMessage:
            this.validation.test(
              ipv6_and_ipv4_with_port.substring(0, ipv6_and_ipv4_with_port.lastIndexOf(':'))
            ) && isPortRange
              ? ''
              : 'Please enter proper port'
        };
      } else {
        this.urlValidationWarningMessage = 'Please enter proper url';
      }
      return {
        isValidUrl: false,
        errorMessage: this.urlValidationWarningMessage
      };
    }
  }
}
